/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const slugify = (val) => {
    return val.toLowerCase().replace(/[^a-zA-Z0-9]+/g, '-');
};
